import {all, call, takeLatest} from 'redux-saga/effects'
import history from '../../history'
import {
  IActionHistoryPush,
} from './actions'
import * as actionTypes from './actionTypes'

/**
 * Redux-saga implementation for directing the browser to the `Path` specified by the `action.payload`
 * and adding the `Path` to browser history
 * @param action
 */
export function* historyPushRequest(action: IActionHistoryPush) {
  yield call(history.push, action.payload)
}

function* saga() {
  yield all([
    takeLatest<IActionHistoryPush>(
      actionTypes.HISTORY_PUSH_REQUEST,
      historyPushRequest,
    ),
  ])
}

export default saga



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/store/history/saga.ts